var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBnb(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_161_1217)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 -0.666626C24.8372 -0.666626 32 6.49619 32 15.3334C32 24.1706 24.8372 31.3334 16 31.3334C7.16282 31.3334 0 24.1706 0 15.3334C0 6.49619 7.16282 -0.666626 16 -0.666626Z",
    fill: "#F0BE0B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.73485 15.8777L7.74809 20.7301L11.8712 23.1563V25.9972L5.33512 22.1638V14.4588L7.73485 15.8777ZM7.73485 11.0253V13.8529L5.33365 12.4325V9.60488L7.73485 8.18445L10.1478 9.60488L7.73485 11.0253ZM13.593 9.60488L15.9942 8.18445L18.4072 9.60488L15.9942 11.0253L13.593 9.60488Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.47037 19.7243V16.8835L11.8716 18.3039V21.1315L9.47037 19.7243ZM13.5934 24.1738L15.9946 25.5943L18.4076 24.1738V27.0015L15.9946 28.4219L13.5934 27.0015V24.1738ZM21.8513 9.60488L24.2525 8.18445L26.6655 9.60488V12.4325L24.2525 13.8529V11.0253L21.8513 9.60488ZM24.2525 20.7301L24.2658 15.8777L26.667 14.4573V22.1623L20.1309 25.9957V23.1548L24.2525 20.7301Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5291 19.7243L20.1279 21.1315V18.3039L22.5291 16.8834V19.7243Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5307 12.0312L22.5439 14.872L18.4091 17.2982V22.1624L16.0079 23.5696L13.6067 22.1624V17.2982L9.47184 14.872V12.0312L11.8833 10.6107L15.9932 13.0487L20.128 10.6107L22.541 12.0312H22.5307ZM9.47037 7.18025L15.9946 3.33362L22.5307 7.18025L20.1295 8.60068L15.9946 6.16271L11.8716 8.60068L9.47037 7.18025Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_161_1217"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBnb);
export default __webpack_public_path__ + "static/media/bnb.77730c5b47a622f09d906744b04815ab.svg";
export { ForwardRef as ReactComponent };